let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("doHJv")).then(() => parcelRequire('bNJtO'));